module.exports = __webpack_public_path__ + "img/banner5.444c56dd.png";